module.exports = __webpack_public_path__ + "img/bg_main_t_l_3.e99ba930.png";